var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(`color: ${_vm.color}; width: ${_vm.size}px; height: ${_vm.size}px; background`),attrs:{"src":`line/icons/${_vm.name}.svg`,"alt":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }